export type {
  TeachingPopoverTitleBaseProps as TeachingPopoverTitleProps,
  TeachingPopoverTitleBaseState as TeachingPopoverTitleState,
  TeachingPopoverTitleSlots,
} from '@fluentui/react-teaching-popover';
